import React, { useState } from "react";
import { httpBatchLink } from "@trpc/client";
import { queryClient } from "@/lib/utils/queryUtils";
import { store } from "@/lib/states/store";
import { supabase } from "@/lib/supabase/supabaseClient";
import { trpc } from "./client";

const apiUrl = () =>
  `${import.meta.env.VITE_API_URL ?? "http://127.0.0.1:8790"}/trpc`;

export const TrpcProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: apiUrl(),
          async headers() {
            const { data } = await supabase.auth.getSession();
            const token = data.session?.access_token;
            const orgId = store.getState().session.org?.id ?? null;

            return {
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
              ...(orgId ? { "x-org-id": orgId } : {}),
            };
          },
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      {children}
    </trpc.Provider>
  );
};
